<script setup lang="ts">
import ClaimCreateDialog from '@/components/asicw/claims/ClaimCreateDialog.vue'
import ClaimsTable from '@/components/asicw/tables/ClaimsTable.vue'
import type { IClaimDashboard } from '@/types/asicw/claims'
import ViewLayout from '@/views/layouts/ViewLayout.vue'
import { ref } from 'vue'
import { Plus } from '@element-plus/icons-vue'
import { useOIDCStore } from '@/stores/oidc.store'

const claimDialogOpen = ref<boolean>(false)
const claimBeingUpdated = ref<IClaimDashboard | undefined>(undefined)

const { isASICWOperationalUser } = useOIDCStore()

const onAddClaim = () => {
  claimDialogOpen.value = true
  claimBeingUpdated.value = undefined
}
</script>

<template>
  <ViewLayout class="claims">
    <ClaimsTable />
    <template #controls>
      <el-button v-if="isASICWOperationalUser" type="primary" :icon="Plus" @click="onAddClaim">Submit Claims</el-button>
    </template>
    <ClaimCreateDialog v-if="claimDialogOpen" v-model="claimDialogOpen" :claim-id="claimBeingUpdated?.id" />
  </ViewLayout>
</template>
